<template>
  <div id="home" class="punishList">
    <Title :title="'Penalty inquiry'"></Title>
    <div class="punish">
      <div class="item" v-for="item in data" :key="item">
        <div>
          <div class="label">{{ $t("message.strid15") }}:</div>
          <span>{{ item.violation_time }}</span>
        </div>
        <div>
          <div class="label">{{ $t("message.strid16") }}:</div>
          <span>{{ item.reason }}</span>
        </div>
        <div v-if="item.is_appeal != '-1'">
          <div class="label">{{ $t("message.strid22") }}:</div>
          <span :class="type[item.is_appeal]">{{
            $t("message." + violation_result[item.is_appeal])
          }}</span>
          <!-- violation_result[item.is_appeal] -->
        </div>
        <div>
          <div class="label">{{ $t("message.strid17") }}:</div>
          <span>{{ item.unlock_time }}</span>
        </div>
        <div class="btn appealed" v-if="item.is_appeal == 0">
          {{ $t("message.strid19") }}
        </div>
        <div
          class="btn Appeal"
          v-if="item.is_appeal == '-1'"
          @click="showMaskFn(item.id)"
        >
          {{ $t("message.strid18") }}
        </div>
        <a
          class="btn service"
          target="_blank"
          :href="aihelp"
          v-if="item.is_appeal == 2"
          @click="openHelp"
        >
          <!-- {{ $t("message.strid43") }} -->
          <p>{{ $t("message.strid43") }}</p>
          <!-- <p>service</p> -->
        </a>
      </div>
    </div>

    <MTmask :show.sync="showMask">
      <div class="tipBox">
        <div class="tipTitle">{{ $t("message.strid24") }}</div>
        <div class="tipclose" @click="showMask = false"></div>
        <div class="tipcontent">
          {{ $t("message.strid38") }}
        </div>
        <router-link :to="{ path: 'formDate', query: { id: index } }">
          <div class="checkBtn know">{{ $t("message.strid44") }}</div>
        </router-link>
        <div class="checkBtn no" @click="showMask = false">
          {{ $t("message.strid45") }}
        </div>
      </div>
    </MTmask>
  </div>
</template>

<script>
import { punishList, getDetail, getCode } from "@/proxy/index";
import Title from "@/components/Title";
import MTmask from "@/components/Mask";

export default {
  components: {
    MTmask,
    Title,
  },
  created() {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
  },
  data() {
    return {
      languageList: ["en"],
      inviteCode: "invite",
      showMask: false,
      index: "",
      type: {
        0: "appealed",
        1: "success",
        2: "fail",
      },
      violation_result: {
        "-1": "未申诉",
        0: "strid20",
        1: "strid23",
        2: "strid21",
      },
      aihelp: "",
      data: [],
      errCode: {},
    };
  },
  mounted() {
    document.querySelector("#loadingMask").style.display = "none";
    //取消请求

    this.getList();
    this.getCode();
  },
  methods: {
    getCode(lang) {
      getCode(window.localStorage.getItem("selfservicelang")).then((res) => {
        (res.data.errcode || []).map((item) => {
          this.errCode[item.code] = item.lang || "";
        });
      });
    },
    getList() {
      punishList(
        window.localStorage.getItem("selfservicelang"),
        Cookies.get("token")
      ).then((res) => {
        console.log(res);
        if (res.data.code == 0) {
          this.data = res.data.data;
        } else if (res.data.code == -20020) {
          Cookies.remove("token");
          this.$router.push({
            path: "home",
          });
        } else {
          layer.open({
            content: this.errCode[res.data.code] || res.data.code,
            skin: "msg",
            time: 2,
          });
        }
      });
    },
    showMaskFn(index) {
      this.index = index;
      this.showMask = true;
    },
    openHelp() {
      switch (window.localStorage.getItem("selfservicelang")) {
        case "en":
          this.aihelp =
            "https://aihelp.net/questionnaire/#/?formId=16a1dc685006452d84131982538cb1c0";
          break;
        case "id":
          this.aihelp =
            "https://aihelp.net/questionnaire/#/?formId=3057616f75ae4fb7be21aa2923fa00be";
          break;
        case "pt":
          this.aihelp =
            "https://aihelp.net/questionnaire/#/?formId=68133af9800d4a539288e3cd630b1744";
          break;
        case "th":
          this.aihelp =
            "https://aihelp.net/questionnaire/#/?formId=5993ee0f03024f6a89a4ebf3c55ea3e7";
          break;
        case "tw":
          this.aihelp =
            "https://aihelp.net/questionnaire/#/?formId=f8eac78c60074a659d5ffcee67514da4";
          break;
        default:
          this.aihelp =
            "https://aihelp.net/questionnaire/#/?formId=16a1dc685006452d84131982538cb1c0";

          break;
      }
    },
  },
};
</script>

<style lang="scss">
@import "~@/assets/scss/views/punish.scss";
</style>
